/* eslint-disable */
<template>
  <div class="isloading">
    <p>Loading...</p>
  </div>
</template>

<script>
export default {
  name: "Loading"
};
</script>

<style lang="css" scoped>
</style>